<activar-modal [visible]="true" [closable]="!deleting()" (visibleChange)="dismissed.emit()">
	<div class="flex-col mx-auto p-5 text-center" style="width: 400px">
		<h2>¿Eliminar API key?</h2>
		<p>
			¿Eliminar la key {{ apiKey().name }} (act_{{ apiKey().prefix }}_…)? Todo lo que la use va a dejar de funcionar
			inmediatamente.
		</p>

		<div class="flex mt-7 items-center justify-center gap-5">
			<activar-button
				data-testid="cancel"
				text="Cancelar"
				fill="out"
				expand="full"
				color="primary"
				[disabled]="deleting()"
				(click)="dismissed.emit()" />
			<activar-button
				data-testid="confirm"
				text="Eliminar"
				fill="solid"
				expand="full"
				color="danger"
				[disabled]="deleting()"
				(click)="confirm.emit()" />
		</div>
	</div>
</activar-modal>
